import React from 'react';
import { withStyles } from 'tss-react/mui';
import Chip from '@mui/material/Chip';
import { S_DSUP } from '@lba-dev/package.local-globals/nStatus';

import styles from './styles';
import LocalGlobalsIcon from '../../utils/localGlobalsIcons';

const NotificationChip = ({ classes, elem }) => {
  let component = <Chip key={elem.name}
    label={elem.shortName} className={classes.chip}
    style={{ backgroundColor: elem.color['500'] }}
  />;
  if (elem.Icon && elem._id === S_DSUP) {
    component = <div className={classes.devisIcon}>
      <LocalGlobalsIcon name={elem.Icon} key={elem.name} style={{
        color: elem.color[500]
      }} />
      <span className={classes.devisIconSpan} key={`${elem.name}span`}
        style={{ color: elem.color[500] }} >+1</span>
    </div>;
  } else if (elem.Icon) {
    component = <LocalGlobalsIcon name={elem.Icon} key={elem.name} style={{
      color: typeof elem.color === 'string' ? elem.color : elem.color[500]
    }} />;
  }
  return component;
};

export default withStyles(NotificationChip, styles);
